
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDivide as ObiDivideElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-divide.js';
 
 
 

 
 export const ObiDivide = createComponent({
   react: React,
   tagName: 'obi-divide',
   elementClass: ObiDivideElement,
   events: {
     
   }
  });
 
 